import LazyLoad from "vanilla-lazyload";
import "./components/product-quantity";
import "./blocks/wavy-openers";

// Resize elements
const resizeElements = () => {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
};

if (document.querySelector(".showcoupon")) {
	document.querySelector(".showcoupon").addEventListener("click", (e) => {
		e.preventDefault();

		document
			.getElementById("checkout-form-coupon-panel")
			.classList.add("checkout-panel--active");

		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		});
	});
}
if (document.querySelector(".showlogin")) {
	document.querySelector(".showlogin").addEventListener("click", (e) => {
		e.preventDefault();

		document
			.getElementById("checkout-form-login-panel")
			.classList.add("checkout-panel--active");

		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		});
	});
}

if (document.querySelectorAll(".js-close-checkout-panel")) {
	document
		.querySelectorAll(".js-close-checkout-panel")
		.forEach((closeBtn) => {
			closeBtn.addEventListener("click", (e) => {
				e.preventDefault();

				e.target
					.closest(".checkout-panel")
					.classList.remove("checkout-panel--active");
			});
		});
}

if (document.querySelectorAll('.wp-block-accordion__header')) {
	const accordionOpeners = document.querySelectorAll('.wp-block-accordion__header');
	accordionOpeners.forEach((accordionOpener) => {
		accordionOpener.addEventListener('click', (e) => {
			e.preventDefault();
			if (!e.target.closest('.wp-block-accordion').classList.contains('wp-block-accordion--active')) {
				e.target.closest('.wp-block-accordion').classList.add('wp-block-accordion--active')
			} else {
				e.target.closest('.wp-block-accordion').classList.remove('wp-block-accordion--active')
			}
		})
	})
}

if (document.querySelector('.js-menu-opener')) {
	document.querySelector('.js-menu-opener').addEventListener('click', (e) => {
		e.stopImmediatePropagation();
		e.preventDefault();
		if (!e.target.classList.contains('menu-opener--active')) {
			e.target.classList.add('menu-opener--active');
			document.querySelector('.wp-block-responsive-menu-wrapper').classList.add('wp-block-responsive-menu-wrapper--active');
			document.querySelector('.site-header').classList.add('site-header--menu-is-open');
			document.querySelector('.theme-atelier-coiffure').classList.add('no-scroll');
		} else {
			e.target.classList.remove('menu-opener--active');
			document.querySelector('.wp-block-responsive-menu-wrapper').classList.remove('wp-block-responsive-menu-wrapper--active');
			document.querySelector('.site-header').classList.remove('site-header--menu-is-open');
			document.querySelector('.theme-atelier-coiffure').classList.remove('no-scroll');
		}
	});
}

if (document.querySelector('.js-products-filters-opener')) {
	document.querySelector('.js-products-filters-opener').addEventListener('click', (e) => {
		e.stopImmediatePropagation();
		e.preventDefault();
		document.querySelector('.wp-block-products-filters').classList.add('wp-block-products-filters--active');
		document.querySelector('.site-header').classList.add('site-header--menu-is-open');
		document.querySelector('.theme-atelier-coiffure').classList.add('no-scroll');
	});

	document.querySelector('.js-products-filters-closer').addEventListener('click', (e) => {
		e.stopImmediatePropagation();
		e.preventDefault();
		document.querySelector('.wp-block-products-filters').classList.remove('wp-block-products-filters--active');
		document.querySelector('.site-header').classList.remove('site-header--menu-is-open');
		document.querySelector('.theme-atelier-coiffure').classList.remove('no-scroll');
	});
}

window.addEventListener("load", () => {
    resizeElements();

    // lazy load pictures 
    new LazyLoad();

	if (document.querySelectorAll('p.stars a')) {
		document.querySelectorAll('p.stars a').forEach((star) => {
			star.addEventListener('mouseenter', (e) => {
				// clean classes 
				document.querySelectorAll('p.stars a').forEach((star) => {
					star.classList.remove('star--active');
				});

				const value = parseInt(e.target.classList.value.replace('star-', ''), 10);
				for(let i = 1; i <= value; ++i) {
					document.querySelector('a.star-' + i).classList.add('star--active');
				}
			});
			star.addEventListener('click', (e) => {
				e.preventDefault();
				const value = parseInt(e.target.classList.value.replace('star-', ''), 10);
				document.getElementById('rating').value = value;
			});
		})
	}
});

window.addEventListener("resize", () => {
    resizeElements();
});

window.addEventListener("scroll", () => {
    if (window.innerHeight * 0.5 < window.scrollY) {
        document.querySelector('header.site-header').classList.add('site-header--mini');
    } else {
        document.querySelector('header.site-header').classList.remove('site-header--mini');
    }
});